module.exports = __webpack_public_path__ + "img/title.39ca877d.png";